export default function CTASection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-gradient-to-br from-[#0B1F3B] to-[#0B1F3B]/90 rounded-2xl p-12 lg:p-16 text-center">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Inizia la Valutazione del Tuo Brand
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
            Scopri il valore patrimoniale del tuo marchio con una pre-analisi gratuita. Ricevi un report preliminare in 48 ore.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/contatti"
              className="px-8 py-4 bg-[#E879F9] text-white rounded-md text-base font-semibold hover:bg-[#E879F9]/90 transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              Richiedi Pre-analisi Gratuita
            </a>
            <a
              href="/contatti"
              className="px-8 py-4 bg-transparent border-2 border-[#22C55E] text-[#22C55E] rounded-md text-base font-semibold hover:bg-[#22C55E] hover:text-white transition-all whitespace-nowrap cursor-pointer"
            >
              Contatta un Consulente
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
